var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0003 1.99953C14.0004 1.7797 13.9281 1.56596 13.7945 1.39137C13.6609 1.21678 13.4735 1.09107 13.2613 1.03369C13.0491 0.976309 12.8239 0.990457 12.6205 1.07394C12.4172 1.15743 12.247 1.3056 12.1363 1.49553L5.1363 13.4955C5.04762 13.6475 5.0006 13.8202 5.00001 13.9961C4.99941 14.1721 5.04525 14.3451 5.13289 14.4977C5.22054 14.6502 5.34689 14.777 5.49919 14.8651C5.65149 14.9532 5.82434 14.9996 6.0003 14.9995H10.0003V21.9995C10.0002 22.2194 10.0725 22.4331 10.2061 22.6077C10.3397 22.7823 10.5271 22.908 10.7393 22.9654C10.9515 23.0228 11.1767 23.0086 11.3801 22.9251C11.5834 22.8416 11.7536 22.6935 11.8643 22.5035L18.8643 10.5035C18.953 10.3516 19 10.1789 19.0006 10.0029C19.0012 9.82697 18.9553 9.65398 18.8677 9.50141C18.7801 9.34884 18.6537 9.22209 18.5014 9.13397C18.3491 9.04585 18.1763 8.99948 18.0003 8.99953H14.0003V1.99953Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/_lightning.25442e8a2b85469becfeec2832a50c45.svg";
export { ForwardRef as ReactComponent };